<div class="dashletActivity">
  @switch (type) {
    @case (customFieldTypes.PERCENTAGE) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_PERCENTAGE_ACTIVITY"
        />
    }
    @case (customFieldTypes.NUMBERS) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_NUMBERS_ACTIVITY"
        />
    }
    @case (customFieldTypes.COST) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.CUSTOM_FIELD_COST_ACTIVITY"
        />
    }
    @case (EIntegrationStatus.ON) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL"
        />
    }
    @case (EIntegrationStatus.DISABLED) {
      <img
        class="dashletActivity__icon"
        [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL"
        />
    }
  }

  <div class="dashletActivity__text">
    <ng-container>
      <span class="dashletActivities__item-quoted timeline__strong">{{ ppChange.label }}</span>
      {{ 'subfield' | ppTranslate }}

      @if (ppChange.newValue && !ppChange.oldValue) {
        <span
          >{{ 'added' | ppTranslate }}
          <span class="dashletActivities__item-quoted"> {{ ppChange.newValue }}</span>
        </span>
      }
      @if (ppChange.newValue && ppChange.oldValue) {
        <span>
          {{ 'updated_to' | ppTranslate }}
          <span class="dashletActivities__item-quoted">{{ ppChange.newValue }}</span></span
          >
        }
        @if (!ppChange.newValue && ppChange.oldValue) {
          <span
            ><span class="dashletActivities__item-quoted">{{ ppChange.newValue }}</span>
            {{ 'deleted' | ppTranslate }}</span
            >
          }
        </ng-container>
      </div>
    </div>
